import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { merge, fromEvent } from 'rxjs';
import { map, switchAll } from 'rxjs/operators';
import { LocalStorage } from '../enums/local-storage-key.enum';
import { LocalStorageService } from './local-storage.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  lang: string;
  constructor(
    private translate: TranslateService,
    private localStorage: LocalStorageService
  ) {

    this.lang = this.getLang();
  }
  getUTCDate(date: any) {
    if (date instanceof Date) {
      var d = date;
    } else {
      var d = new Date(date);
    }

    return this.formatStringLeadingZero("" + d.getUTCDate(), 2) + "-" + this.formatStringLeadingZero("" + (d.getUTCMonth() + 1), 2) + "-" + d.getUTCFullYear();
  }


  formatNumber2Digits(num: number) {
    return ("0" + num).slice(-2)
  }

  formatStringLeadingZero(str: string, length: number) {
    var formattedString = ("000000000" + str).slice(-length);
    return formattedString;
  }

  formatNumber(str: string) {
    var num = parseInt(str);
    return parseFloat("" + Math.round(num * 100) / 100).toFixed(2);
  }

  // getLang() {
  //   const lang= this.localStorage.get(LocalStorage.LANG)
  //   return lang ? lang : 'en';
  // }

  getLang(): string {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const lang = this.localStorage.get(LocalStorage.LANG);

        if (!lang || lang === 'undefined' || lang === 'null') {
          return 'en';
        }

        return lang;
      }
    } catch (e) {
      console.warn('localStorage not accessible', e);
    }

    return 'en';
  }


  changeLang(langCode: string): void {
    this.setLang(langCode);
    this.translate.setDefaultLang(this.getLang());
  }

  setLang(lang: string) {
    const setLang = lang;
    // const setLang ='en';
    this.localStorage.set(LocalStorage.LANG, setLang);
  }

  setDefaultLang(lang: string): void {
    if (!this.getAvailableLang().includes(lang)) {
      lang = 'en';
    }
    this.localStorage.set(LocalStorage.LANG, lang);
    this.translate.setDefaultLang(lang);
  }

  getAvailableLang(): string[] {
    return ['en', 'kr', 'ch', 'jp'];
  }

  getNetworkChangeObservable() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true))
    )
  }
  get avalableGender(): string[] {
    return ["M", "F"]
  }
  public load(callback, ...urls) {
    let count = 0;
    let element;
    urls.forEach(url => {
      if (url.endsWith("js")) {
        element = document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        document.getElementsByTagName('body')[0].appendChild(element);
      }
      if (url.endsWith("css")) {
        element = document.createElement('link');
        element.rel = "stylesheet";
        element.href = url;
        document.getElementsByTagName('head')[0].appendChild(element);
      }
      if (callback) {
        element.addEventListener("load", function () {
          count++;
          if (count == urls.length) {
            callback(urls);
          }
        });
      }

    })

  }
  b64toBlob(dataURI: string, type: string) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
  }

  // setDate_dd_MMM_YYYY(date: any) {
  //   var d = new Date(date);
  //   let momentDate = moment(d).utcOffset("+07:00");
  //   let year = d.getFullYear().toString().replace('-', '');
  //   return [momentDate.format('DD'), momentDate.locale(this.getLang()).format('-MMM-'), year].join('');
  // }

  setDate_dd_MMM_YYYY(date: any): string {
    const d = new Date(date);
    const momentDate = moment(d).utcOffset("+07:00");
    const lang = this.getLang();
    const dateFormat = this.getFormats(lang);
    const formattedDate = momentDate.locale(this.lang).format(dateFormat);
    return `${formattedDate}`;
  }

  setDate_DD_MMM_YYYY(date: any) {
    var d = new Date(date);
    let momentDate = moment(d).utcOffset("+07:00");
    let year = d.getFullYear().toString().replace('-', '');
    return [momentDate.format('DD'), momentDate.locale(this.getLang()).format(' MMM '), year].join('');
  }

  setDateToday_DD_MMM_YYYY(date: any) {
    var d = new Date(date);
    let momentDate = moment(d).utcOffset("+07:00");
    const lang = this.getLang();
    const dateFormat = this.getFormats(lang, 'today');
    const formattedDate = momentDate.locale(this.lang).format(dateFormat);
    return `${formattedDate}`;
  }

  setDate_dddd_D_MMM_YYYY(date: any): string {
    var d = new Date(date);
    let momentDate = moment(d).utcOffset("+07:00");
    let year = d.getFullYear().toString().replace('-', '');
    return [momentDate.format(' DD '), momentDate.format('MMMM'), year].join('');
  }

  setDate_dddd_MMMM_DD_YYYY_hh_mm_ss_A(date: any) {
    let momentDate = moment(date).utcOffset("+07:00");
    const lang = this.getLang();
    let dateFomat = this.getDateTranslation(momentDate, 'LT', lang);
    return `${dateFomat}`;

  }

  setDate_UTCCambodia(date: any): string {
    var d = new Date(date);
    let momentDate = moment(d).utcOffset("+07:00");
    return momentDate.format('DD MMMM YYYY');
  }

  set_UTC_Cambodia(date: any): string {
    let d = new Date(date);
    let momentDate = moment(d).tz('Asia/Phnom_Penh');
    return momentDate.format('DD MMMM YYYY');
  }

  setDate_Ticket_Day(date: any): string {
    var d = new Date(date);
    let momentDate = moment(d).utcOffset("+07:00");
    return momentDate.locale(this.getLang()).format('dddd');
  }

  setDate_Ticket(date: any): string {
    var d = new Date(date);
    const lang = this.getLang();
    let momentDate = moment(d).utcOffset("+07:00");
    let dateFomat = this.getDateTranslation(momentDate, 'TK', lang);
    return `${dateFomat}`;
  }

  setDate_dd_MMM_YYYY_Detail(date: any): string {
    if (!date || isNaN(new Date(date).getTime())) {
      return 'Invalid Date';
    }
    const d = new Date(date);
    const momentDate = moment(d).utcOffset("+07:00");
    const lang = this.getLang();
    const dateFormat = this.getFormats(lang);
    const ampmLocalized = this.getAMPMFormat(lang, momentDate.format('A'));
    const time = momentDate.format('hh:mm');
    const formattedDate = momentDate.locale(lang).format(dateFormat);
    return `${formattedDate} ${time} ${ampmLocalized}`;
  }

  getFormats(lang: string, type?: string): string {
    const formats = {
      kr: ['DD-M일-YYYY', 'DD M일 YYYY'],
      jp: ['DD-M月-YYYY', 'DD M月 YYYY'],
      ch: ['DD-M日-YYYY', 'DD M日 YYYY'],
      km: ['DD-MMMM-YYYY', 'DD MMMM YYYY'],
      default: ['DD-MMM-YYYY', 'DD MMMM YYYY'],
    };
    return (type === 'today' ? (formats[lang]?.[1] || formats.default[1]) : (formats[lang]?.[0] || formats.default[0]));
  }

  getDateTranslation(momentDate, type: string, lang: string): string {
    const months = {
      en_long: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ],
      ch: [
        '一月', '二月', '三月', '四月', '五月', '六月',
        '七月', '八月', '九月', '十月', '十一月', '十二月',
      ],
      kr: [
        '1월', '2월', '3월', '4월', '5월', '6월',
        '7월', '8월', '9월', '10월', '11월', '12월',
      ],
      jp: [
        '1月', '2月', '3月', '4月', '5月', '6月',
        '7月', '8月', '9月', '10月', '11月', '12月',
      ],
    };

    const daysOfWeek = {
      en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      ch: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'],
      kr: ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'],
      jp: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
    };

    let year = momentDate.format('YYYY');
    let nameOfDay = momentDate.locale(this.getLang()).format('dddd');
    let day = momentDate.format('DD');
    let month = momentDate.locale(this.getLang()).format('MMMM');
    const ampmLocalized = this.getAMPMFormat(lang, momentDate.format('A'));
    const time = momentDate.format('hh:mm:s');

    const monthIndex = months.en_long.findIndex(month => month === month);
    const dayIndex = daysOfWeek.en.findIndex(day => day === nameOfDay);
    const dayTranslate = daysOfWeek[lang]?.[dayIndex] || day;
    const monthTranslate = months[lang]?.[monthIndex] || month;

    return type === 'TK' ? `${dayTranslate}  ${day}  ${monthTranslate} ${year}` : `${dayTranslate}, ${monthTranslate} ${day}, ${year} ${time} ${ampmLocalized}`;
  }

  getAMPMFormat(lang: string, ampm: string): string {
    const ampmMapping = {
      kr: { AM: '오전', PM: '오후' },
      jp: { AM: '午前', PM: '午後' },
      ch: { AM: '上午', PM: '下午' },
      km: { AM: 'ព្រឹក', PM: 'ល្ងាច' },
    };
    return ampmMapping[lang]?.[ampm] || ampm;
  }

}


